import { useState } from "react";
import { Fragment } from "react";
import {
  Autocomplete,
  Switch,
  Grid2 as Grid,
  FormControlLabel,
  TextField,
} from "@mui/material";
import BTDialogBox from "../../../components/BTDialgBox";
import BTInput from "../../../components/BTInput";
import secureLocalStorage from "react-secure-storage";
import authService from "../../../services/auth-service";
import { CircularProgress } from "@mui/material";
import { useNotification } from "../../../context";
import { Notifications } from "@mui/icons-material";
import { isEqual } from "lodash";
import moment from "moment";
import { manage_store_data } from "../../../store/functions";
import { useDispatch } from "react-redux";
import { get, insert, update, remove } from "../../../store/labSlice";
const Addconversion = ({ open, setOpen, conversionRate }) => {
  const { addNotification } = useNotification();
  const dispatch = useDispatch();
  const { value, actionType } = open;
  const { u_id, admin_u_id, u_type } = secureLocalStorage.getItem("userdata");
  const initialState = {
    cnv_date: moment().format("YYYY-MM-DD HH:mm:ss"),
    cnv_rate: null,
    cnv_description: null,
    cnv_created_by: u_id,
    parent_u_id: u_id,
    admin_u_id: u_type === 1 ? u_id : admin_u_id,
    cnv_updated_by: u_id,
  };
  const [formData, setFormData] = useState(
    actionType === 1 ? initialState : value
  );
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const validateForm = (data) => {
    const { cnv_date, cnv_rate } = data;
    const errors = {};
    const addError = (field, message) => (errors[field] = message);
    if (!cnv_date) {
      addError("cnv_date", "Date is required");
    } else {
      const dateExists = conversionRate?.data.some(
        (rate) =>
          moment(rate.cnv_date).format("YYYY-MM-DD") ===
          moment(cnv_date).format("YYYY-MM-DD")
      );
      if (dateExists) {
        errors.cnv_date = "Conversion rate for this date already exists";
      }
    }
    if (!cnv_rate) {
      addError("cnv_rate", "Rate is required");
    }
    if (cnv_rate < 0) {
      addError("cnv_rate", "Rate must be greater than 0");
    }
    return Object.keys(errors).length > 0 ? errors : {};
  };
  const handleClose = () => {
    setOpen(false);
    setFormData(initialState);
  };

  const submitCnvrate = async (e) => {
    e.preventDefault();
    const newErrors = validateForm(formData);
    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      if (actionType === 2 && isEqual(formData, value)) {
        return addNotification({
          icon: <Notifications color="white" />,
          title: "Error!",
          message: "No changes to save",
          color: "error",
        });
      } else {
        try {
          setLoading(true);
          const isNewRecord = !formData?.cnv_id;
          const response = isNewRecord
            ? await authService.insert_cnv_rate({ attributes: formData })
            : await authService.update_cnv_rate({ attributes: formData });
          if (response?.status === 1) {
            isNewRecord
              ? dispatch(
                  insert({
                    name: "conversionRate",
                    data: response?.data,
                    fetch: true,
                  })
                )
              : dispatch(
                  update({
                    name: "conversionRate",
                    key: "cnv_id",
                    data: response?.data,
                    type: true,
                  })
                );
            addNotification({
              icon: <Notifications color="white" />,
              title: "Success!",
              message: response?.message,
              color: "success",
            });
            handleClose();
          }
        } catch (error) {
          addNotification({
            icon: <Notifications color="white" />,
            title: "Error!",
            message: "Somthing Went Wrong!",
            color: "error",
          });
        } finally {
          setLoading(false);
        }
      }
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const fieldValue = type === "checkbox" ? checked : value;
    setFormData((prev) => ({
      ...prev,
      [name]: fieldValue,
    }));
    const newErrors = validateForm({ ...formData, [name]: fieldValue });
    if (Object.keys(newErrors).length === 0) {
      setErrors((prevErrors) => {
        const { [name]: removedError, ...rest } = prevErrors;
        return rest;
      });
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: newErrors[name] || null,
      }));
    }
  };

  const handleAutocompleteChange = (name, value) => {
    let fieldValue = value?.value || "";
    setFormData((prev) => ({
      ...prev,
      [name]: fieldValue,
    }));
    const newErrors = validateForm({ ...formData, [name]: fieldValue });
    if (Object.keys(newErrors).length === 0) {
      setErrors((prevErrors) => {
        const { [name]: removedError, ...rest } = prevErrors;
        return rest;
      });
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: newErrors[name] || null,
      }));
    }
  };

  const handleSwitchChange = (name) => (e) => {
    setFormData((prev) => ({
      ...prev,
      [name]: e.target.checked ? 1 : 0,
    }));
  };

  const renderField = (field) => {
    const error = errors[field?.name];
    switch (field.type) {
      case "select":
        return (
          <Autocomplete
            disableClearable
            options={field?.options}
            value={
              field?.options.find(
                (opt) => opt.value === formData[field.name]
              ) || null
            }
            onChange={(_, value) => handleAutocompleteChange(field.name, value)}
            renderInput={(params) => (
              <TextField
                {...params}
                label={field.label}
                variant="standard"
                fullWidth
                error={!!error}
                helperText={error}
                required={field?.required}
              />
            )}
          />
        );

      case "checkbox":
      case "switch":
        return (
          <FormControlLabel
            control={
              <Switch
                checked={Boolean(formData[field.name]) || false}
                onChange={handleSwitchChange(field.name)}
                color="secondary"
              />
            }
            label={field.label}
            labelPlacement="start"
            sx={{
              justifyContent: "space-between",
              marginLeft: 0,
              marginRight: 0,
              width: "100%",
            }}
          />
        );

      default:
        return (
          <BTInput
            name={field.name}
            label={field.label}
            type={field.type || "text"}
            value={formData[field.name] || ""}
            onChange={handleChange}
            variant="standard"
            fullWidth
            required={field?.required}
            error={!!error}
            helperText={error}
            {...field.props}
          />
        );
    }
  };

  const formFields = [
    {
      name: "cnv_date",
      label: "Date",
      type: "datetime-local",
      gridSize: { xs: 12, md: 4 },
      required: true,
    },
    {
      name: "cnv_rate",
      label: "Rate",
      type: "number",
      gridSize: { xs: 12, md: 4 },
      required: true,
    },
    {
      name: "cnv_description",
      label: "Description",
      type: "text",
      gridSize: { xs: 12, md: 4 },
    },
  ];

  return (
    <BTDialogBox
      open={Boolean(open)}
      fullWidth
      maxWidth="md"
      onSubmit={submitCnvrate}
      close={handleClose}
      title={actionType === 1 ? "Add " : "Edit user"}
      buttons={[
        {
          name: "Cancel",
          color: "secondary",
          size: "small",
          onClick: handleClose,
        },
        {
          name: actionType === 1 ? "Submit" : "Edit",
          variant: "gradient",
          type: "submit",
          color: "dark",
          size: "small",
          loading: loading,
          loadingComponent: (
            <Fragment>
              <svg width={0} height={0}>
                <defs>
                  <linearGradient
                    id="my_gradient"
                    x1="0%"
                    y1="0%"
                    x2="0%"
                    y2="100%">
                    <stop offset="0%" stopColor="#e01cd5" />
                    <stop offset="100%" stopColor="#1CB5E0" />
                  </linearGradient>
                </defs>
              </svg>
              <CircularProgress
                size={22}
                sx={{
                  "svg circle": { stroke: "url(#my_gradient)" },
                }}
              />
            </Fragment>
          ),
          sx: { ml: 2, width: "80px" },
        },
      ]}>
      <Grid container spacing={1}>
        {formFields.map((field) => (
          <Grid size={{ ...field.gridSize }} key={field.name}>
            {renderField(field)}
          </Grid>
        ))}
      </Grid>
    </BTDialogBox>
  );
};

export default Addconversion;
